module.exports = __webpack_public_path__ + "static/img/13.9f6178d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/sp/13.png
// module id = BDA5
// module chunks = 0